import React, { useState } from "react";
import { Dialog, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import LanguageSelect from "../components/LanguageSelect";
import "./EersteKeerModal.css";
import person from "../img/person.png";
import useHttp from "../hooks/use-http";
import useStore from "../stores/useStore";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import { GB, NL } from "country-flag-icons/react/3x2";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const EersteKeerModal = ({
  languageSaved,
  setLanguageSaved,
  headerVariant,
  hideFlag = false,
}) => {
  const { i18n, t } = useTranslation();
  const [language, setLanguage] = useState("nl");
  const { user } = useStore();

  const {
    sendRequest: setLanguageRequest,
    isLoading: setLanguageLoading,
    error: setLanguageError,
  } = useHttp();

  function setLanguageHandler() {
    function applyData(res) {
      i18n.changeLanguage(language);
      setLanguageSaved(true);
    }

    setLanguageRequest(
      {
        url: `${REACT_APP_BACKEND_URL}/user_management/set_preferred_language`,
        method: "POST",
        body: {
          sub: user?.sub || "",
          language: language,
        },
      },
      applyData
    );
  }

  return (
    <React.Fragment>
      {headerVariant && (
        <div className="language-header">
          {!hideFlag && (
            <>
              {i18n.language === "nl" ? (
                <NL style={{ width: "20px", height: "20px"}} />
              ) : (
                <GB style={{ width: "1.5rem", height: "auto" }} />
              )}
            </>
          )}
          {hideFlag && (
            <span
              style={{
                fontSize: "16px",
                color: "#2D2D2D",
                fontWeight: "400",
              }}
            >
              {i18n.language === "nl" ? "Nederlands" : "English"}
            </span>
          )}
          <span
            className="pointer"
            style={{
              fontSize: "16px",
              color: "#439BD9",
              fontWeight: "500",
              marginLeft: hideFlag ? "8px" : "0px",
              textDecoration: hideFlag ? "none" : "underline"
            }}
            onClick={() => setLanguageSaved(false)}
          >
            {hideFlag ? "Aanpassen" : (i18n.language === "nl" ? "Nederlands" : "English")}
          </span>
        </div>
      )}
      <Dialog
        open={languageSaved === false}
        onClose={headerVariant ? () => setLanguageSaved(true) : null}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className="eerste-keer-modal">
          <div className="ekm-main-container">
            {headerVariant ? <h1>{t("taal")}</h1> : <h1>Welkom!</h1>}
            <div className="select-language-container">
              <span className="select-language">
                {t("Selecteer jouw taal")}
              </span>
            </div>
            <div className="ekm-lng-select">
              <LanguageSelect
                handleSelectLanguage={setLanguage}
                languageValue={language}
              />
            </div>
            <div>
              <Button
                variant="contained"
                sx={{ mt: 2, mr: 1, textTransform: "none", borderRadius: "40px", padding: "8px 16px", fontSize: "14px", fontWeight: 600 }}
                onClick={setLanguageHandler}
                disabled={setLanguageLoading}
              >
                {t("Selecteer")}
              </Button>
            </div>
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default EersteKeerModal;
